// Component-local images contain only the verified, saved PDF. No persistent cache.
export default {
    data: () => ({ pdfThumbnail: "", pdfThumbnailRevision: 0 }),
    computed: {
        pdfPreviewKey() { return `${this.articolo}:${this.disegno}`; },
    },
    watch: {
        pdfPreviewKey() { this.pdfThumbnail = ""; this.pdfThumbnailRevision = 0; },
    },
    methods: {
        acceptPdfPreview({ article, drawing, revision, url }) {
            if (this._isDestroyed || article !== this.articolo || drawing !== this.disegno) return;
            if (revision && revision < this.pdfThumbnailRevision) return;
            this.pdfThumbnail = url || "";
            this.pdfThumbnailRevision = revision || 0;
        },
    },
};
